/* ══ THE MAKE YOURS TEASE ════════════════════════════════════════════════════
   CLIENT: "when the first movie loads you expand up the form as if they clicked
   on Make Yours for like 2 seconds and then toggle it to hide it and then give
   the button a smokey purple animated glow around the button to draw attention
   to it." Then: "make it every time until they manually press the button, then
   set a cookie or appdata to not do it after that."

   THE TWO HALVES HAVE DIFFERENT LIFETIMES, AND THAT IS DELIBERATE.

     · THE AUTO-EXPAND IS A TEACH. It repeats on every load for as long as the
       visitor has not found MAKE YOURS, and a genuine press of the button
       retires it permanently on that device.
     · THE GLOW IS DECORATION, AND IT IS PERMANENT. Client: "glow stays." It is
       NOT gated on the discovery flag and it does not stop after the press --
       it marks the primary action on a page whose every other pixel is moving
       film, so it keeps doing that for a visitor who already knows what it is.

   The practical consequence worth knowing: a returning visitor who has pressed
   the button sees the glow and no auto-expand, which is the intended resting
   state of the page rather than a bug.

   WHY THIS IS ITS OWN FILE. Self-contained hint layer, one entry point, no
   state anybody else reads. Deleting this file is a complete uninstall.
   ═════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  if (window.__BMVH_TEASE_BOOTED) return;
  window.__BMVH_TEASE_BOOTED = true;

  var root = document.querySelector(".bmvh");
  if (!root) return;
  var btn = root.querySelector("#formToggle");
  if (!btn) return;
  var form = root.querySelector("#customForm");

  /* Same family as the page's other client-side prefs (bm.tv.fit.v1,
     bm.tv.seen.v1). EVERY read and write is wrapped: private browsing and
     blocked site data throw on access, and the correct fallback is always
     "no flag, so the tease runs" -- never an exception on boot. */
  var KEY = "bm.tv.tease.v1";
  function discovered() {
    try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  }
  function remember() {
    try { localStorage.setItem(KEY, "1"); } catch (e) {}
  }

  var SETTLE = 900;   /* let the first film actually be on screen first */
  var HOLD   = 2000;  /* the client's "like 2 seconds" */
  var GIVEUP = 240;   /* poll ceiling: 240 x 250ms = 60s, then stop for good */

  var phoneQ  = window.matchMedia ? window.matchMedia("(max-width:760px)") : null;
  var reduceQ = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  var REDUCE  = !!(reduceQ && reduceQ.matches);

  var started = false, over = false, tries = 0, timers = [];

  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
  }

  /* ── WHAT COUNTS AS DISCOVERY ────────────────────────────────────────────
     A GENUINE PRESS ONLY, AND isTrusted IS WHAT GUARANTEES IT. The tease
     never dispatches an event -- it sets the class and the aria attributes
     directly (see setFold) -- so no synthetic path can reach these handlers at
     all. isTrusted is the second lock: even a future refactor that started
     calling btn.click() could not mark the visitor as having discovered the
     button, which is the failure that would disable the tease on its own very
     first run and never fire again.

     Tapping MAKE YOURS during the tease DOES count -- it is a real press, so
     the tease aborts, their tap is honoured, and the flag is written.

     THE FORM'S OWN CONTROLS COUNT TOO. Reaching a field, the photo button or
     the submit button means the fold is open and the visitor is working inside
     it; someone typing where they like to get high has unambiguously found the
     feature and does not need to be taught it again. Submitting obviously
     counts -- they have commissioned a film. */
  function discover(e) {
    if (e && !e.isTrusted) return;
    remember();
    unwatch();
    /* NOTE: the glow is deliberately left alone. Discovery retires the
       auto-expand only -- see the lifetimes note in the header. */
  }
  var DISCOVER_EV = ["pointerdown", "keydown"];
  function watch() {
    for (var i = 0; i < DISCOVER_EV.length; i++) {
      btn.addEventListener(DISCOVER_EV[i], discover, { passive: true });
      if (form) form.addEventListener(DISCOVER_EV[i], discover, { passive: true });
    }
    if (form) form.addEventListener("submit", discover);
  }
  function unwatch() {
    for (var i = 0; i < DISCOVER_EV.length; i++) {
      btn.removeEventListener(DISCOVER_EV[i], discover);
      if (form) form.removeEventListener(DISCOVER_EV[i], discover);
    }
    if (form) form.removeEventListener("submit", discover);
  }

  function glow() { btn.classList.add("mfold-glow"); }

  /* THE AGE GATE HOLDS EVERYTHING. The channel does not reach data-state
     "playing" until the gate is answered, so that check alone already covers
     this; the explicit test is belt and braces.
     NOTE display, NOT offsetParent: .bm-age-gate is position:fixed, and
     offsetParent is null for every fixed element whether it is on screen or
     not -- a guard written that way is inert and silently always false. The
     gate's own script toggles style.display between "flex" and "none". */
  function gateUp() {
    var m = document.getElementById("bm-age-modal");
    if (!m) return false;
    return getComputedStyle(m).display !== "none";
  }

  /* The channel cross-fades between two <video> elements; the one on screen
     carries .is-live. Ask the live one, not a fixed id. */
  function film() {
    return root.querySelector("video.film.is-live") || document.getElementById("video");
  }

  /* "Trigger on the first film actually playing, not on cold load" -- a still
     frame with the film still arriving is exactly what this must not tease
     over, so require real progressed playback, not just the state flag. */
  function channelUp() {
    if (!(phoneQ && phoneQ.matches)) return false;
    if (gateUp()) return false;
    if (root.getAttribute("data-state") !== "playing") return false;
    var f = film();
    return !!(f && !f.paused && f.currentTime > 0.15);
  }

  /* THE FOLD, WITHOUT THE SIDE EFFECTS. The button's real click handler in
     bm-channel.js also calls chNoteInteraction(), which zeroes the channel's
     auto-advance counter and skips the hero hold. A hint the visitor did not
     ask for must not reprogram the channel's pacing, so this sets exactly the
     state a tap would leave behind -- the class, aria-expanded and the matching
     aria-label -- and nothing else. It dispatches no event, so it can never be
     mistaken for a press by the discovery handlers above. It touches no network
     path either: the fold is a disclosure, and only #customBtn commissions. */
  function setFold(open) {
    root.classList.toggle("m-form-shut", !open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    var lbl = btn.getAttribute(open ? "data-open-label" : "data-shut-label");
    if (lbl) btn.setAttribute("aria-label", lbl);
  }

  /* Ends the tease. Deliberately does NOT write the flag: finishing the teach
     is not the visitor learning it, and marking here would retire the nudge
     after one load for someone who never looked at it. */
  function finish() {
    if (over) return;
    over = true;
    clearTimers();
    detach();
    glow();
  }

  /* ANY REAL INPUT WINS, IMMEDIATELY. The timers stop where they are and the
     fold is left EXACTLY as the visitor found it -- deliberately not restored.
     If they tapped MAKE YOURS itself, its own handler has already toggled the
     fold and closing it again here would collapse the form under their thumb,
     which is the one failure mode this must never have. */
  var EVENTS = ["pointerdown", "touchstart", "mousedown", "keydown", "wheel"];
  function onIntent() { if (started) finish(); }
  function attach() {
    for (var i = 0; i < EVENTS.length; i++) {
      document.addEventListener(EVENTS[i], onIntent, { capture: true, passive: true });
    }
  }
  function detach() {
    for (var i = 0; i < EVENTS.length; i++) {
      document.removeEventListener(EVENTS[i], onIntent, { capture: true });
    }
  }

  function run() {
    if (started) return;
    started = true;
    attach();
    later(function () {
      if (over) return;
      setFold(true);
      later(function () {
        if (over) return;
        setFold(false);
        finish();
      }, HOLD);
    }, SETTLE);
  }

  /* Only worth listening for a press while the auto-expand is still live --
     once the flag is set there is nothing left for a press to switch off. */
  var known = discovered();
  if (!known) watch();

  var poll = setInterval(function () {
    if (started || over) { clearInterval(poll); return; }
    if (++tries > GIVEUP) { clearInterval(poll); return; }
    if (!channelUp()) return;
    clearInterval(poll);
    /* The glow goes on for everyone, every load, the moment the first film is
       genuinely playing -- gated on that only so it never pops in over the
       loading plate. What follows it is what varies. */
    glow();
    /* Already pressed it on this device: glow only, no teach. */
    if (known) { started = true; over = true; return; }
    /* Under reduce: no auto-expand either. The glow stays as a static
       affordance -- the stylesheet's reduce block stops it animating. */
    if (REDUCE) { started = true; over = true; return; }
    run();
  }, 250);
})();
